import type { JobViewModelItemPartial } from 'src/types/JobViewModel.ts';
import { useSelector } from 'src/store/react';
import { selectNormalisedCompanyName } from 'src/store/results/results';
import { useQualifiedLinkParams } from 'src/modules/qualified-location';
import { useJobCardEnrichedLocation } from 'src/modules/enriched-location';
import { useLinkProps } from '../../../../NavLink/NavLink.tsx';
import type { SearchParams } from '@seek/chalice-types';

export function useLocationLinks({
  isJobExternal,
  unifiedLocation,
}: {
  isJobExternal: boolean;
  unifiedLocation?: JobViewModelItemPartial[] | null;
}) {
  const normalisedCompanyName = useSelector(selectNormalisedCompanyName);
  const rel = isJobExternal ? 'nofollow' : undefined;
  const getQualifiedLinkParams = useQualifiedLinkParams({
    rel,
    shouldUseUrlResolver: true,
  });
  const getJobCardEnrichedLocation = useJobCardEnrichedLocation();
  const getLinkProps = useLinkProps({
    getQualifiedLinkParams,
    rel,
  });

  return unifiedLocation?.map((item) => {
    const { params: query, name, title } = item;
    const normalisedQuery: SearchParams = normalisedCompanyName
      ? {
          ...query,
          keywords: normalisedCompanyName,
        }
      : query;

    const linkProps = getLinkProps(
      getJobCardEnrichedLocation({
        pathname: '/jobs',
        query: normalisedQuery,
      }),
    );

    return {
      name,
      title,
      ...linkProps,
    };
  });
}
